module.exports = __webpack_public_path__ + "img/invision.a033a301.svg";